import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

const Base = styled.div`
  font-weight: ${select.fontWeight("normal")};
  color: ${select.color(["grey", 6])};
  padding: ${select.space(0)} ${select.space(2)};
  font-size: ${select.fontSize(-1)};
  cursor: pointer;
  transition: ${select.speed("fast")};
  font-family: ${select.font("Lato")};
  background-color: transparent;
  user-select: none;

  &:hover {
    background-color: ${select.color(["grey", 0])};
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  closeOnClick?: boolean;
};

function Item({ style, className, children, ...rest }: Props, ref: any) {
  return (
    <Base ref={ref} style={style} className={className} {...rest}>
      {children}
    </Base>
  );
}

export default React.forwardRef(Item);
